import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["$isVisible"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import useFocused from 'UIComponents/hooks/useFocused';
import { useFetchHighlySensitivePropertyValue } from './useFetchHighlySensitivePropertyValue';
import styled from 'styled-components';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { useState } from 'react';

// Can remove this manually prop-omitting nonsense when styled-components transient props are supported
// https://styled-components.com/docs/api#transient-props
// https://git.hubteam.com/HubSpot/Frontend/issues/1770
import { jsx as _jsx } from "react/jsx-runtime";
export const LoadingButton = styled(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_ref => {
  let props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UILoadingButton, Object.assign({}, props));
}).withConfig({
  displayName: "ShowHighlySensitiveValueButton__LoadingButton",
  componentId: "sc-1ly9ate-0"
})(["transition:opacity 0.2s;opacity:", ";"], ({
  $isVisible
}) => $isVisible ? 1 : 0);
export function ShowHighlySensitiveValueButton(props) {
  const {
    isVisible,
    className
  } = props;
  const {
    fetchHighlySensitivePropertyValue,
    highlySensitiveValueStatus
  } = useFetchHighlySensitivePropertyValue();
  const isLoading = highlySensitiveValueStatus === 'LOADING';
  const {
    onFocus,
    onBlur,
    focused
  } = useFocused({});
  const [showValueFailed, setShowValueFailed] = useState(false);
  return /*#__PURE__*/_jsx(LoadingButton, {
    className: className,
    size: "extra-small",
    use: "tertiary-light"
    // This prevents the success checkmark from showing when loading failed
    ,
    failed: showValueFailed,
    onClick: () => {
      setShowValueFailed(false);
      fetchHighlySensitivePropertyValue().catch(() => {
        setShowValueFailed(true);
        FloatingAlertStore.addAlert({
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataProperties.PropertyInputHighlySensitive.showValueErrorTitle"
          }),
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataProperties.PropertyInputHighlySensitive.showValueErrorMessage"
          }),
          type: 'danger'
        });
      });
    },
    loading: isLoading,
    onFocus: onFocus,
    onBlur: onBlur,
    $isVisible: isVisible || isLoading || focused,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.PropertyInputHighlySensitive.showValue"
    })
  });
}